var messages = {
  zoomInText: '放大',
  zoomOutText: '缩小',
  rotateRightText: '顺时针旋转90°',
  resetText: '原图大小',
  copyText: '复制',
  downloadText: '下载',
  originalText: '切换到100%',
  tipsContent: '按 ESC 即可退出全屏模式'
};
export default messages;